export default __webpack_public_path__ + "static/media/large-frame-bg1.4fb256ad.svg";